var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.teamName))]),_c('div',{staticClass:"score"},[_vm._v(_vm._s(_vm.score))])])
}
var staticRenderFns = []

export { render, staticRenderFns }